import { CurrencyNumber, PercentageFloat } from '../common/lang/numbers';

export function getReturnOnInvestment(revenue: CurrencyNumber, expenditure: CurrencyNumber): CurrencyNumber {
    const roi = revenue - expenditure; // Much math!
    return roi;
}

export function getReturnOnInvestmentPercent(revenue: CurrencyNumber, expenditure: CurrencyNumber): PercentageFloat {
    const roi = getReturnOnInvestment(revenue, expenditure);
    if (expenditure === 0) {
        return Number.POSITIVE_INFINITY;
    }
    return roi / expenditure;
}
